<template>
    <div>

        <form id="recuperar-senha" @submit.prevent="submit" class="form">
            <div>
                <label class="label">Nova Senha:</label>
                <input  type="password" class="input" v-model="dados.senha" autocomplete="new-password">
            </div>

            <div>
                <label class="label">Repita a Senha:</label>
                <input  type="password" class="input" v-model="dados.confirmacao_senha" autocomplete="new-password">
            </div>

            <div id="erro-validacao" v-if="dados.senha && dados.confirmacao_senha && dados.senha != dados.confirmacao_senha">
                Senhas não conferem
            </div>

            <div class="right-align mt-2">
                <button type="submit" class="button" :disabled="carregando">
                    Salvar
                </button>
            </div>
        </form>
    </div>
</template>

<script>

import { api } from "@/helpers/api";

export default {

    data() {
        return {
            recuperacao_senha: null,
            dados:{
                senha: null,
                confirmacao_senha: null
            },
            carregando: false
        }
    },

    async created() {

        const token = this.$route.params.token;

        try{
            const {data: {result: {data: recuperacao_senha}}} = await api.get(`recuperacao-senha/${token}`);
            this.recuperacao_senha = recuperacao_senha;
        } catch(e) {
            await this.$swal('Ops!', e.response.data.statusMessage);
            this.$router.push({name: 'Login'})
        }

    },


    methods: {

        async submit() {

            this.carregando = true;

            try{

                await api.put(`recuperacao-senha/${this.recuperacao_senha.token}`, this.dados);

            } finally {
                this.carregando = false;
            }


            await this.$swal('Parabéns!', 'Sua senha foi modificada com sucesso! Clique em OK e faça o login para continuar.');

            this.$router.push({name: 'Login'});

        }
    }



}
</script>



// WEBPACK FOOTER //
// src/components/auth/RecuperarSenha.vue